// Parses Google's distance string ("1.2 km", "850 m") to meters.
export function parseDistanceMeters(s?: string): number {
  if (!s) return 0;
  const num = parseFloat(s.replace(",", "."));
  if (!isFinite(num)) return 0;
  return /km/i.test(s) ? num * 1000 : num;
}

// Rough cost model in EUR. Approximate, just to give a sense.
// car: fuel ~0.10€/km. transit: flat ~1.50€ per leg. bike/walk: 0. scooter: ~0.25€/min.
export function estimateCostEUR(
  mode: "walk" | "scooter" | "bike" | "car" | "transit",
  totalMeters: number,
  totalMinutes: number,
  legCount: number,
): number {
  if (mode === "walk" || mode === "bike") return 0;
  if (mode === "car") return (totalMeters / 1000) * 0.10;
  if (mode === "transit") return legCount * 1.5;
  if (mode === "scooter") return totalMinutes * 0.25;
  return 0;
}

export function formatKm(meters: number): string {
  if (meters < 1000) return `${Math.round(meters)} m`;
  return `${(meters / 1000).toFixed(1)} km`;
}

export function formatDurationMin(min: number): string {
  if (min < 60) return `${Math.round(min)} min`;
  const h = Math.floor(min / 60);
  const m = Math.round(min % 60);
  return m === 0 ? `${h}h` : `${h}h${m.toString().padStart(2, "0")}`;
}
